import React, { useState } from "react";
import { useProfileParams } from "../../../../../../utils/common";
import KPITile from "../../../../../common/KPITile/KPITile";
import KPIDetailTile from "../../../../../common/KPIDetailTile/KPIDetailTile";
import DonutChart, {
  DonutChartSegment,
} from "../../../../../common/DonutChart/DonutChart";
import styles from "../../../LegAnalysis/structure/QMix/QMixTile.module.scss";
import InsightAI from "../../../../../common/InsightAI/InsightAI";
import { useTranslation } from "react-i18next";
import ViewModeSwitcher, {
  ViewMode,
} from "../../../../../common/ViewModeSwitcher/ViewModeSwitcher";
import Skeleton from "../../../../../common/Skeleton/Skeleton";
import PeriodDropdown, {
  PeriodOption,
} from "../../../../../common/PeriodDropdown/PeriodDropdown";
import subCategoryStyles from "./SubCategory.module.scss";
import CategoryPerformanceView from "../../Shared/CategoryPerformanceView/CategoryPerformanceView";

const monthlyData = {
  kpiCode: "business-line",
  detail: {
    chart: {
      chartSummary: {
        kpiValue: 0,
        kpiDataType: "number",
      },
      chartDetail: {
        lineChartDetail: null,
        tableDetail: {
          header: {
            row: [
              { kpiValue: "Sub<br> Category" },
              { kpiValue: "Sep" },
              { kpiValue: "Oct" },
              { kpiValue: "Nov" },
              { kpiValue: "Dec" },
              { kpiValue: "Jan" },
              { kpiValue: "Feb" },
              { kpiValue: "Mar" },
              { kpiValue: "Apr" },
              { kpiValue: "May" },
              { kpiValue: "Jun" },
            ],
          },
          body: {
            rows: [
              [
                {
                  kpiValue: "Accessories-Beauty",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 6890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1945,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 5789,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1034,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 5560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 15697,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 8901,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 20000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 6000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 11000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 5600,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Durables",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Home Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Nutrition",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Personal Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Catalog",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Other",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Unknown",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],

              [
                {
                  kpiValue: "Bundles-Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 624890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 610340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 598210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 579650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 562330,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 548910,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 531760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 518430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 507890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 492560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 589650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 575430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 562210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 548650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 532330,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 518910,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 501760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 488430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 477890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 462560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 389650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 378430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 369890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 358210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 349560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 337890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 328450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 319760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 312430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 304980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 354650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 345430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 337890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 328210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 319560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 307890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 298450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 289760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 282430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 274980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],

              [
                {
                  kpiValue: "Bundles-Other Beauty",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 214560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 209340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 203210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 198450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 192780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 187430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 181650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 176890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 172450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 168320,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 204560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 199340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 193210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 188450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 182780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 177430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 171650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 166890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 162450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 158320,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 129780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 126430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 123560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 120890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 118430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 115980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 113650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 108210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 105890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 119780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 116430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 113560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 108430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 105980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 103650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 100430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 98210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 95890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],

              [
                {
                  kpiValue: "Bundles-Skin Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 214560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 209340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 203210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 198450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 192780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 187430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 181650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 176890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 172450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 168320,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 204560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 199340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 193210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 188450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 182780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 177430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 171650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 166890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 162450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 158320,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 129780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 126430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 123560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 120890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 118430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 115980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 113650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 108210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 105890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 119780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 116430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 113560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 108430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 105980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 103650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 100430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 98210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 95890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Cleanser",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 624890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 610340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 598210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 579650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 562330,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 548910,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 531760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 518430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 507890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 492560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 589650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 575430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 562210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 548650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 532330,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 518910,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 501760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 488430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 477890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 462560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 389650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 378430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 369890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 358210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 349560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 337890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 328450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 319760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 312430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 304980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 354650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 345430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 337890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 328210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 319560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 307890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 298450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 289760,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 282430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 274980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Cosmetics-Other",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 6890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1945,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 5789,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1034,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 5560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 15697,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 8901,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 20000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 6000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 11000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 5600,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Devices-Skin Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 214560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 209340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 203210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 198450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 192780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 187430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 181650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 176890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 172450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 168320,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 204560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 199340,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 193210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 188450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 182780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 177430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 171650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 166890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 162450,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 158320,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 129780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 126430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 123560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 120890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 118430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 115980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 113650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 108210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 105890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 119780,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 116430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 113560,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 108430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 105980,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 103650,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 100430,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 98210,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 95890,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Eye Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Face Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25($)
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24($)
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 25(BV)
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24(BV)
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
            ],
          },
        },
      },
    },
  },
  kpiCurrency: "USD",
};

const yearlyData = {
  kpiCode: "business-line",
  detail: {
    chart: {
      chartSummary: {
        kpiValue: 0,
        kpiDataType: "number",
      },
      chartDetail: {
        lineChartDetail: null,
        tableDetail: {
          header: {
            row: [
              { kpiValue: "Year" },
              { kpiValue: "YOY Change<br>($)" },
              { kpiValue: "Yearly Total<br>($)" },
              { kpiValue: "YOY Change<br>(BV)" },
              { kpiValue: "Yearly Total<br>(BV)" },
            ],
          },
          body: {
            rows: [
              [
                {
                  kpiValue: "Accessories-Beauty",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 145000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                        yoy: "STLY"
                      },
                      {
                        kpiValue: 34344,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 230000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 34344,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 120000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 23424,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 23424,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    //PY21
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 180000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 23424,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Bundles-Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Bundles-Other Beauty",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Cleanser",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Cosmetics-Other",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Devices-Skin Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Eye Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Face Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Lip Cosmetics",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Mask",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Moisturizer",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Selling Support-Beauty",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Toner",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Treatment",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Undefined-Other Beauty",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Undefined-Skin Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Durables",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 245000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 24567,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 230000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 34344,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 120000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 23424,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 110000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 23424,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                    //PY21
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 180000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 10,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 23424,
                        kpiDataType: "number",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Home Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Catalog",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Nutrition",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Personal Care",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Other",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Unknown",
                  kpiDataType: "string",
                  children: [
                    // PY 25
                    [
                      {
                        kpiValue: "PY 25",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -20,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: -30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 60500,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 24
                    [
                      {
                        kpiValue: "PY 24",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 23
                    [
                      {
                        kpiValue: "PY 23",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    // PY 22
                    [
                      {
                        kpiValue: "PY 22",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 21",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 30,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 45000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50,
                        kpiDataType: "percentage",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 50000,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
            ],
          },
        },
      },
    },
  },
  kpiCurrency: "USD",
};

interface SummaryProp {
  summary?: any;
  loading?: boolean;
}

export const SubCategory: React.FC<SummaryProp> = ({
  summary,
  loading = false,
}) => {
  // Display API-provided segments when available; otherwise show nothing (0 fallback is implicit per segment values)
  const segments: DonutChartSegment[] = Array.isArray(summary?.segments)
    ? summary!.segments
    : [];
  const { t } = useTranslation();

  return (
    <KPITile
      title={t("sub_category")}
      dataTestId="sub-category-tile"
      loading={loading}
      className={styles.center_content}
    >
      <div className={styles.tile_content}>
        <DonutChart
          size={125}
          strokeWidth={20}
          legendGap={24}
          segments={segments}
          showLegend
          isPortfolio
        />
      </div>
    </KPITile>
  );
};

export const SubCategoryDetails: React.FC<{
  kpiCode?: string;
  onClose?: () => void;
}> = ({ kpiCode = "sub-category", onClose }) => {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState<ViewMode>("left");
  const [aiContent, setAiContent] = useState<string>("");
  const [selectedPeriod, setSelectedPeriod] = useState<string>("py25");

  const hasDonutChartData = false;

  const periodOptions: PeriodOption[] = [
    { label: "PY 25", value: "py25" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
  ];

  const tableData = [];
  const isLoadingAiSummary = false;

  const headerContent = (
    <div className={styles.header_content}>
      <div className={styles.tile_header}>
        <div className={styles.title}>{t("subcategory.title")}</div>
        <div className={styles.desc}>{t("subcategory.description")}</div>
      </div>
      <div className={styles.chart_view_wrapper}>
        <ViewModeSwitcher
          mode={viewMode}
          onChangeMode={setViewMode}
          disabled={false}
          showSwitch={hasDonutChartData}
        />
      </div>
    </div>
  );

  const leftContent = (
    <div className={subCategoryStyles.left_content_wrapper}>
      <div className={subCategoryStyles.dropdown_wrapper}>
        <PeriodDropdown
          options={periodOptions}
          selectedValue={selectedPeriod}
          onSelect={(value) => setSelectedPeriod(value)}
        />
      </div>
      {selectedPeriod === "py25" ? (
        <CategoryPerformanceView
          viewType="chart"
          showTabs={true}
          title={t("subcategory.subtitle")}
        />
      ) : selectedPeriod === "monthly" ? (
        <CategoryPerformanceView
          viewType="table"
          data={monthlyData}
          title={t("subcategory.monthly_title")}
          description={t("categorymix.sales_performance_description")}
          highlightColumns={[]}
        />
      ) : (
        <CategoryPerformanceView
          viewType="table"
          data={yearlyData}
          title={t("subcategory.yearly_title")}
          description={t("categorymix.sales_performance_description")}
          highlightColumns={[1, 3]}
          groupedColumnClass
        />
      )}
    </div>
  );

  const rightContent = isLoadingAiSummary ? (
    <Skeleton height="200px" />
  ) : (
    <InsightAI
      updateDate=""
      content={aiContent}
      title={t("ai_summary")}
      showDropdown={false}
      isDropdownEnabled={true}
      flowerIconSize={24}
      titleSize={14}
    />
  );

  return (
    <KPIDetailTile
      headerContent={headerContent}
      leftContent={leftContent}
      rightContent={rightContent}
      onClose={onClose!}
      dataTestId="sub_category_detail"
    />
  );
};

export default SubCategory;
